  <script>
    import * as animateScroll from "svelte-scrollto";
    export let siteLinks;

    animateScroll.setGlobalOptions({
      duration: 250
    });

    function scrollToTop() {
      animateScroll.scrollToTop();
      let navBar =  document.getElementById('navbarNavAltMarkup');
      navBar.classList.remove("show");
    }
	</script>
	<!-- ================== Footer Section ================ -->
  <footer class="py-5 footer-alignment px-5">
    <div class="container">

      <div class="row py-4">
        <div class="col-md-4">
          <img class="img-fluid" src="assets/img/logo.svg" alt="ORDRK">
        </div>

        <div class="col-md-2">
          <h4 class="footer-h-title text-white">Products</h4>
          <a on:click={scrollToTop} class="footer-subtitle" href="{siteLinks.features}">Features</a>
          <a on:click={scrollToTop} class="footer-subtitle" href="{siteLinks.pricing}">Pricing</a>
        </div>

        <div class="col-md-2">
          <h4 class="footer-h-title text-white">Service</h4>
          <a class="footer-subtitle" href="https://ordrk.freshdesk.com/">Help Center</a>
          <a class="footer-subtitle" on:click={scrollToTop} href="/contact">Contact</a>
        </div>

        <div class="col-md-2">
          <h4 class="footer-h-title text-white">Social</h4>
          <a class="footer-subtitle" href="https://www.instagram.com/ordrk.app/"><img src="assets/img/instagram.svg" alt="Instagram"> &nbsp;  Instagram</a>
          <a class="footer-subtitle" href="https://www.twitter.com/ordrk_app/"><img src="assets/img/twitter.svg" alt="twitter">&nbsp;  Twitter</a>
        </div>

        <div class="col-md-2" id="app-links">
          <h4 class="footer-h-title text-white">Get The App</h4>
          <a class="text-light footer-subtitle" href="{siteLinks.PlayStore}"><img class="img-fluid" src="assets/img/play-store.svg"
              alt="Play Store"></a>
          <a class="text-light footer-subtitle" href="{siteLinks.AppStore}"><img class="img-fluid" src="assets/img/apple-store.svg"
              alt="App Store"></a>
        </div>
      </div>
    </div>
    <hr>
    <!-- ====  Terms and conditions ===-->
    <div class="container">
      <div class="row pt-3">
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-5">
              <a class="text-light terms-section-fonts" href="https://alephdigital.net">&copy; Aleph Digital Platforms LLC</a>
            </div>
            <div class="col-md-2 col-off-">
              <a class="text-light terms-section-fonts" on:click={scrollToTop} href="/terms">Terms of use</a>
            </div>
            <div class="col-md-2">
              <a class="text-light terms-section-fonts" on:click={scrollToTop} href="/privacy">Privacy policy</a>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="padding-top: 1.25rem;">
              <p class="ter-n-con-pra" style="margin-bottom: 0.5rem;">Apple, and the Apple logo, are trademarks of Apple Inc., registered in the U.S.
                and other countries. App Store is a service mark of Apple Inc.</p>
              <p class="ter-n-con-pra">Google Play and the Google Play logo are trademarks of Google LLC.</p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
	<style>
		footer a:hover { color: white; }
    #app-links a, a.terms-section-fonts { opacity: 0.9; }
    #app-links a:hover, a.terms-section-fonts:hover { opacity: 1.0; }
	</style>